"use client";

import { Link } from "@/i18n/Link";
import { trackContentClick } from "@/lib/analytics/trackContentClick";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokContentCard } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import type { StoryblokMultilink } from "storyblok";
import { AssetBlok, sizes } from "../Asset";
import BlokWrap from "../BlokWrap";
import styles from "./ContentCardBlok.module.css";

export const ContentCardBlok = ({
	blok,
	className,
}: BlokProps<BlokContentCard> & { className?: string }) => {
	const { title, media, text, link } = blok;
	const linkUrl = sbLink(link as StoryblokMultilink);

	const CardContent = (
		<article className={styles.content}>
			<div className={styles.imageContainer}>
				{media && <AssetBlok source={media} sizes={sizes(50, 33, 25)} />}
			</div>
			<div className={clsx(styles.info, className)}>
				<h3 className={styles.title}>{title}</h3>
				<p className={styles.text}>{text}</p>
			</div>
		</article>
	);

	return (
		<BlokWrap editable={blok} asChild>
			{linkUrl ? (
				<Link
					href={linkUrl.href}
					{...(linkUrl.external && { target: linkUrl.target, rel: "noopener noreferrer" })}
					onClick={() =>
						trackContentClick({
							contentType: blok.component,
							itemId: blok._uid,
							href: linkUrl.href,
							label: title,
						})
					}
				>
					{CardContent}
				</Link>
			) : (
				CardContent
			)}
		</BlokWrap>
	);
};
